export default function retry(fn, retriesLeft, interval) {
  const newRetriesLeft =
    retriesLeft !== undefined && retriesLeft !== null ? retriesLeft : 3;
  const newInterval = interval || 1000;

  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (newRetriesLeft === 0) {
            reject(error);
            return;
          }

          retry(fn, newRetriesLeft - 1, newInterval).then(resolve, reject);
        }, newInterval);
      });
  });
}
